import React, { ComponentProps, FC, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaArrowAltCircleLeft } from 'react-icons/fa';

type Props = React.PropsWithoutRef<ComponentProps<typeof Button>> & {
  readonly loading?: boolean;
};

const ButtonBack: FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Button
      name="button-back"
      {...props}
      className={`d-flex align-items-center gap-2 ${props.className || ''}`}
      variant={props.variant || 'primary'}
      onClick={props.onClick}
      size="sm"
      style={{
        width: '160px',
        fontWeight: 500,
        background: isHovered ? '#0d6efd' : 'transparent',
        border: '1px solid #6ea8fe',
        color: isHovered ? 'white' : '#6ea8fe',
        transition: 'all 0.3s ease',
        ...props.style,
      }}
      onMouseEnter={(e) => {
        setIsHovered(true);
        props.onMouseEnter?.(e);
      }}
      onMouseLeave={(e) => {
        setIsHovered(false);
        props.onMouseLeave?.(e);
      }}
    >
      <FaArrowAltCircleLeft size={18} />
      <span style={{ color: isHovered ? 'white' : '#6ea8fe' }}>{t('Επιστροφή')}</span>
    </Button>
  );
};

export default ButtonBack;
